import * as React from "react";
import { IconProps } from "../types";

const LinkSlashOutlineIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M6.71362 11.2873C6.88572 11.7392 7.15382 12.1629 7.51802 12.527L9.69302 14.702C11.074 16.083 13.312 16.083 14.693 14.702L14.703 14.692C16.084 13.311 16.084 11.073 14.703 9.69199L13.9406 8.9296"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M11.2883 6.71269C11.1162 6.26079 10.8481 5.83709 10.4839 5.47299L8.30887 3.29799C6.92787 1.91699 4.68987 1.91699 3.30887 3.29799L3.29887 3.30799C1.91787 4.68899 1.91787 6.92699 3.29887 8.30799L4.06128 9.07039"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M2.00098 16L16.001 2"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
    );
  },
);

export default LinkSlashOutlineIcon;
